import axios from "../shared/axios";
import { IApiResponse } from "../types/api";

const PREFIX = "/visma";

export function generateVismaUrl() {
  return axios.get<IApiResponse<{ url: string }>>(`${PREFIX}/generate`);
}
